import { NProgress } from '@tanem/react-nprogress';
import { css } from 'emotion';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'react-emotion';
import { withRouter } from 'react-router';
import { NetworkStatusConsumer } from './NetworkStatusContext';
const canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
const MemoizedNProgress = React.memo(({ loading }) => {
    return (React.createElement(NProgress, { isAnimating: loading }, ({ isFinished, progress }) => (React.createElement(Container, { progress: progress, isFinished: isFinished }))));
});
const LoadingBar = function LoadingBar(props) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);
    return (mounted &&
        canUseDOM &&
        ReactDOM.createPortal(React.createElement(NetworkStatusConsumer, null, value => {
            return (React.createElement(MemoizedNProgress, { loading: value.loading, key: props.location.key }));
        }), document.getElementById('root')));
};
const Container = function Container({ progress, isFinished }) {
    return (React.createElement("div", { className: css `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 2147483647;
        opacity: ${isFinished ? 0 : 1};
        transition: opacity 0.4s ease-out;
      ` },
        React.createElement(Bar, { className: css `
          width: ${progress * 100}%;
        ` })));
};
const Bar = styled('div') `
  height: 2px;
  background: ${({ theme }) => theme.colors.loadingBar};
  transition: width 0.1s linear;
`;
export default withRouter(LoadingBar);
//# sourceMappingURL=LoadingBar.js.map